import { PhotoProvider, PhotoView } from "react-photo-view";

const GraphComponent = ({ graph }) => {
  return (
    <div className="monitoring-z-score-div">
      <div className="monitoring-z-score-content">
        <div className="monitoring-image-container">
          <PhotoProvider>
            <PhotoView src={"data:image/jpeg;base64," + graph.image}>
              <img
                alt="monitoring"
                className="monitoring-z-score-img"
                src={"data:image/jpeg;base64," + graph.image}
              />
            </PhotoView>
          </PhotoProvider>
        </div>
      </div>
    </div>
  );
};

export default GraphComponent;
